export enum FormFieldTypes {
  Text = 'text',
  Tel = 'tel',
  Email = 'email',
  Dropdown = 'dropdown',
  Number = 'number',
  Textarea = 'textarea',
  // CheckboxList = 'checkboxlist',
  Checkbox = 'checkbox',
  File = 'file'
}

export interface IFormField {
  required?: boolean;
  // if label is present label will be used instead of labelTranslateKey
  label?: string
  labelTranslateKey?: keyof ITranslations;
  placeholderTranslateKey?: keyof ITranslations;
  model: string;
  type: FormFieldTypes;
  options?: (string | number)[] | { label: string, value: any }[]
  autocomplete?: string;
  allowedExtensions?: string[]
  maxFileSizeInMb?: number
  multiple?: boolean
}

